module.exports = __webpack_public_path__ + "static/img/mail-b.6b6915e1.png";